<ri-dropdown *ngIf="configuration.isMultiSelection" [mainButton]="selectAllButton" [buttons]="selectButtonsList"
             (onClick)="onSelectDropdownClick($event)"></ri-dropdown>
